import moment from "moment";

function monthDiff(dateStart){
    const date = new Date(); 
    const months = moment.duration(moment(date).diff(moment(dateStart))).asMonths()
    //Tiago Barata pediu para deixar 12 meses e depois ira diminuir para um periodo menor
    return months-11;
}

export {
 
    monthDiff
};